/* queryBuilderColumns.js */

/**
 * @module queryBuilderColumns
 *
 * Single source of truth for the columns available in audit-policy
 * `thenExpression` / `elseExpression` query builders. The runtime widgets
 * are constructed in EditAuditPolicyRenderer (`_renderThenAdvancedFilter` /
 * `_renderElseAdvancedFilter`) against the same names — keep them in sync.
 *
 * `operators` mirrors the per-type operator set produced by
 * `AdvancedFilterComponent._getFilterFieldsConfig` for the `string` branch
 * when a non-empty `type` is supplied (the audit-policy then/else builders
 * pass `type: {name: "special", ...}`).
 */
const STRING_SPECIAL_OPERATORS = Object.freeze([
    "must_contain_regex",
    "must_not_contain_regex",
    "must_not_contain_ordered_regex",
    "must_only_contain_regex",
    "must_contain_ordered_regex",
    "must_only_contain_ordered_regex",
    "must_contain",
    "must_not_contain",
    "must_not_contain_ordered",
    "must_only_contain",
    "must_contain_ordered",
    "must_only_contain_ordered",
]);

const THEN_ELSE_COLUMNS = Object.freeze([
    Object.freeze({
        name: "latestConfig",
        label: "Latest Snapshot",
        type: "string",
        input: "textarea",
        operators: STRING_SPECIAL_OPERATORS,
    }),
    Object.freeze({
        name: "defaultConfig",
        label: "Default Snapshot",
        type: "string",
        input: "textarea",
        operators: STRING_SPECIAL_OPERATORS,
    }),
]);

const buildQueryBuilderColumns = () => THEN_ELSE_COLUMNS;

module.exports = {buildQueryBuilderColumns};
